// Dependencies imports
import React from "react";
import { useNavigate } from "react-router-dom";

// Local imports
import { ReactComponent as LeftArrow } from "../../assets/icons/leftarrow.svg";
import LibraryIcon from "../../assets/icons/libraryicon.png";
import { ReactComponent as IssueIcon } from "../../assets/icons/issueicon.svg";
import { ReactComponent as IssuedIcon } from "../../assets/icons/issuedicon.svg";
import { ReactComponent as ReturnIcon } from "../../assets/icons/returnicon.svg";
import { ReactComponent as DoubleRightArrow } from "../../assets/icons/doublerightarrow.svg";

// Style imports
import Mt from "./mtlibrary.module.scss";

const MtLibrary = () => {
  const navigate = useNavigate();

  return (
    <div className={Mt.maincontainer}>
      <div className={Mt.topbar}>
        <LeftArrow onClick={() => navigate(-1)} className={Mt.backbutton} />
      </div>
      <div className={Mt.headingholder}>
        <img src={LibraryIcon} alt="libraryicon" className={Mt.libraryicon} />
        <h3 className={Mt.heading}>Mont. Library</h3>
      </div>
      <div className={Mt.navigationcardholders}>
        <div
          className={Mt.individualcard}
          onClick={() => navigate("/montlibrary/issuekit")}
        >
          <div className={Mt.leftcard}>
            <IssueIcon />
            <h4 className={Mt.navheading}>Issue a kit</h4>
          </div>
          <DoubleRightArrow className={Mt.doublearrow} />
        </div>
        <div
          className={Mt.individualcard}
          onClick={() => navigate("/montlibrary/returnkit")}
        >
          <div className={Mt.leftcard}>
            <ReturnIcon />
            <h4 className={Mt.navheading}>Return a kit</h4>
          </div>
          <DoubleRightArrow className={Mt.doublearrow} />
        </div>
        <div
          className={Mt.individualcard}
          onClick={() => navigate("/montlibrary/issuedkitlog")}
        >
          <div className={Mt.leftcard}>
            <IssuedIcon />
            <h4 className={Mt.navheading}>Issued kit log</h4>
          </div>
          <DoubleRightArrow className={Mt.doublearrow} />
        </div>
      </div>
    </div>
  );
};

export default MtLibrary;
